module.exports = __webpack_public_path__ + "img/apptu2.6c658b04.png";